import { IconPropsDeprecated } from '@umanforge/common';

export const ResolutionLogo = ( { className, size, onClick }: IconPropsDeprecated ) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 163.21976 186.12176"
      className={ className }
      style={{ height: size, width: size }}
      onClick={ onClick }
    >
      <path
        style={{ stroke: 'none' }}
        d="m 111.46456,32.983881 c 7.63061,0.337021 13.13563,5.756218 13.20166,12.995811 0.0797,8.743004 -5.16873,14.060235 -14.12946,14.070199 -34.649043,0.03851 -69.298483,0.08745 -103.9468909,-0.06602 -4.477455,-0.01984 -6.05171205,1.07843 -6.01288605,5.854211 0.224777,27.65082 0.105614,55.304388 0.120743,82.957038 8.77e-4,1.60602 0.158615,3.21194 0.242111,4.79433 H 33.885247 V 92.999652 c 9.5346,0 18.66839,0.19606 27.78619,-0.10019 3.46263,-0.11252 5.33291,1.16452 7.02104,3.93886 6.63614,10.906198 13.43474,21.713528 20.17519,32.556238 10.96542,17.63905 21.932463,35.27709 32.898973,52.91547 1.52279,2.44922 3.1861,3.82349 6.61754,3.81166 l 34.83557,-0.12012 c -19.55803,-31.39384 -38.52803,-61.84383 -57.99984,-93.099278 5.4952,0 9.7562,0.60181 13.79186,-0.0972 27.11781,-4.69721 43.88739,-30.276801 37.66565,-57.076682 C 151.94254,15.333162 132.55289,-9.4128268e-5 111.46924,0 L 0,4.9767172e-4 C 11.280899,17.343642 20.926265,34.978555 32.242107,51.264116 c 0.49793,-0.246552 0.99587,-0.493111 1.4938,-0.739662 l 0.92651,-17.504639 c 25.33203,-0.06032 50.66405,-0.120636 76.802143,-0.03586 z"
      />
    </svg>
  );
};
